import EntryActionTypes from '../constants/EntryActionTypes';

const fetchListReportDataInCurrentList = () => ({
  type: EntryActionTypes.LIST_REPORT_DATA_IN_CURRENT_LIST_FETCH,
});

const upsertListReportDataInCurrentList = (data) => ({
  type: EntryActionTypes.LIST_REPORT_DATA_IN_CURRENT_LIST_UPSERT,
  payload: {
    data,
  },
});

const completeListReportDataInCurrentList = () => ({
  type: EntryActionTypes.LIST_REPORT_DATA_IN_CURRENT_LIST_COMPLETE,
});

const upsertListReportDataByListId = (listId, data) => ({
  type: EntryActionTypes.LIST_REPORT_DATA_BY_LIST_ID_UPSERT,
  payload: {
    listId,
    data,
  },
});

const completeListReportDataByListId = (listId) => ({
  type: EntryActionTypes.LIST_REPORT_DATA_BY_LIST_ID_COMPLETE,
  payload: {
    listId,
  },
});

export default {
  fetchListReportDataInCurrentList,
  upsertListReportDataInCurrentList,
  completeListReportDataInCurrentList,
  upsertListReportDataByListId,
  completeListReportDataByListId,
};
